export default __webpack_public_path__ + "static/water_b.0b3490a34e0e0d400ee642261de9b0ff.png";